module.exports = __webpack_public_path__ + "static/media/4.ab65c3a1.JPG";